import React from "react";

import { Form } from "react-bootstrap";
import styled from "styled-components";

const OTPComponent = ({ setOTP, OTP, errorMessage }) => {
  // Hint: OTP SetState should be set in parant component
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;

    setOTP([...OTP.map((item, i) => (i === index ? element.value : item))]);

    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  // FIXME:  Make previous input focus on backspace keydown
  // const handleBackSpace = (element, index) => {
  //   if (element.key === "Backspace") {
  //     if (element.previousSibling) element.previousSibling.focus();
  //   }
  // };
  return (
    <>
      <OTPWrapper dir="ltr" className="d-flex flex-nowrap justify-content-center">
        {OTP.map((data, index) => {
          return (
            <StyledOTPInputs
              className={`OTP-field ${
                errorMessage ? "border-danger" : "border-primary"
              }`}
              type="text"
              name="OTP"
              maxLength="1"
              key={index}
              value={data}
              onInput={(e) => handleChange(e.target, index)}
              onFocus={(e) => e.target.select()}
              // onKeyDown={(e) => handleBackSpace(e.target, index)}
            />
          );
        })}
      </OTPWrapper>
      <Form.Text className="text-danger">{errorMessage}</Form.Text>
    </>
  );
};

export default OTPComponent;

const OTPWrapper = styled.div`
  column-gap: 5px;
`;

const StyledOTPInputs = styled(Form.Control)`
  &.OTP-field {
    width: 68px;
    height: 75px;
    font-size: var(--font-size-xxl);
    border: 2px solid var(--primary-color);
    display: inline-block;
    text-align: center;
    border-radius: 1rem;
    caret-color: var(--deactive-color);
    @media screen and (max-width: 576px) {
      width: 45px;
      height: 50px;
    }
  }
`;
